<template>
	<v-flex xs12>
			<h2 class='proposta__title'>Composição do Consórcio</h2>
			<v-divider class='mt-3 mb-3'></v-divider>
			<div class="" class='mt-3 mb-3' v-for="(participant, index) in participants" v-if="participants.length" :key="index">
				<v-form >
					<v-layout row wrap>
						<v-flex xs3>
							<v-text-field
							class='jns-input'
							:value="(participant.cnpj_cpf) ? formatCNPJ(participant.cnpj_cpf) : 'Não informado' " 
							disabled	
							label='CNPJ' 
							placeholder=' '/>
						</v-flex>
						<v-flex xs6>
							<v-text-field 
							class='jns-input'	
							v-model='participant.nome' 
							disabled 
							label='Razão Social'	
							placeholder=' '/>
						</v-flex>
						<v-flex xs2>
							<v-text-field 
							class='jns-input'
							v-model='participant.porcentagem' 
							label='% Participação' 
							@keypress="isNumber($event)"
							placeholder=' ' 
							@keyup="$emit('updatePercentageValues')" 
							:disabled="hasParticipants"
							/>
						</v-flex>
						<v-flex xs1 v-if="!hasParticipants && participants.length > 1" class='pt-4 proposta__trash-icon'>
							<span @click="$emit('participantDelete', index)"><v-icon>delete</v-icon></span>
						</v-flex>
					</v-layout>
				</v-form>
			</div>
			<div v-if="!participants.length" class='mb-3'>
				Você não possui nenhum participante ainda.
			</div>
			<span 
				class='proposta__blue-text mt-2' 
				@click.prevent="$emit('addParticipant')"
				v-if="!hasParticipants">
				<v-icon>add_circle</v-icon>Adicionar Participante
			</span>
		</v-flex> 
	</v-layout>
</template>

<style lang='scss' scoped>
</style>

<script lang="js">
import { formatCNPJ, isNumber } from "@/libs/utils";
export default {
  name: "PropostaForm",

  data: () => ({
    formatCNPJ,
    isNumber
  }),
  props: ["participants", "hasParticipants"],
  
};
</script>





// WEBPACK FOOTER //
// ./src/components/ComposicaoConsorcioForm.vue